export const QUIZ_ACTIONS = {
    MANAGE_QUIZ: 'manageQuiz',
    COPY: 'copyQuiz',
    MANAGE_INTEGRATIONS: 'manageIntegrations',
    VIEW_CRM: 'viewCrm',
    MOVE: 'moveQuiz',
    DELETE: 'deleteQuiz',
    RESTORE: 'restoreQuiz',
    SHARE: 'shareQuiz',
    PUBLISH: 'publishQuiz',
}

export const QUIZ_MUTATION_PERMISSION_MAP = {
    updateQuiz: 'can_manage_quiz',
    updateStartPage: 'can_manage_quiz',
    updateFinishPage: 'can_manage_quiz',
    createQuestion: 'can_manage_quiz',
    updateQuestion: 'can_manage_quiz',
    deleteQuestion: 'can_manage_quiz',
    createVariant: 'can_manage_quiz',
    updateVariant: 'can_manage_quiz',
    deleteVariant: 'can_manage_quiz',
    createConsultant: 'can_manage_quiz',
    updateConsultant: 'can_manage_quiz',
    deleteConsultant: 'can_manage_quiz',
    createBenefit: 'can_manage_quiz',
    updateBenefit: 'can_manage_quiz',
    deleteBenefit: 'can_manage_quiz',
    updateContactPage: 'can_manage_quiz',
    createContactPageField: 'can_manage_quiz',
    updateContactPageField: 'can_manage_quiz',
    deleteContactPageField: 'can_manage_quiz',
    createSocialNetwork: 'can_manage_quiz',
    updateSocialNetwork: 'can_manage_quiz',
    deleteSocialNetwork: 'can_manage_quiz',
    updateQuizOptions: 'can_manage_quiz',
    copyQuiz: 'can_copy',
    createIntegration: 'can_manage_integrations',
    updateIntegration: 'can_manage_integrations',
    deleteIntegration: 'can_manage_integrations',
    testIntegration: 'can_manage_integrations',
    createMailchimpAudience: 'can_manage_integrations',
    shareQuiz: 'can_share',
    revokeQuizAccess: 'can_share',
    updateQuizAccessStatus: 'can_share',
    moveQuiz: 'can_transfer',
    deleteQuiz: 'can_delete',
    restoreQuiz: 'can_delete',
}

export const QUIZ_ACTION_PERMISSION_MAP = {
    [QUIZ_ACTIONS.MANAGE_QUIZ]: 'can_manage_quiz',
    [QUIZ_ACTIONS.COPY]: 'can_copy',
    [QUIZ_ACTIONS.MANAGE_INTEGRATIONS]: 'can_manage_integrations',
    [QUIZ_ACTIONS.VIEW_CRM]: 'can_view_crm',
    [QUIZ_ACTIONS.MOVE]: 'can_transfer',
    [QUIZ_ACTIONS.DELETE]: 'can_delete',
    [QUIZ_ACTIONS.RESTORE]: 'can_delete',
    [QUIZ_ACTIONS.SHARE]: 'can_share',
    [QUIZ_ACTIONS.PUBLISH]: 'can_publish',
}

export function getQuizViewerPermissions(quiz = {}) {
    return quiz?.viewer_permissions || null
}

export function isQuizShared(quiz = {}) {
    return Boolean(quiz?.is_shared)
}

export function isQuizOwner(quiz = {}) {
    const permissions = getQuizViewerPermissions(quiz)

    return !isQuizShared(quiz) || Boolean(permissions?.is_owner)
}

export function canUseQuizAction(quiz = {}, action) {
    if (isQuizOwner(quiz)) {
        return true
    }

    const permissionKey = QUIZ_ACTION_PERMISSION_MAP[action] || QUIZ_MUTATION_PERMISSION_MAP[action]

    if (!permissionKey) {
        return true
    }

    const permissions = getQuizViewerPermissions(quiz)

    return Boolean(permissions?.[permissionKey])
}

export function canManageQuiz(quiz = {}) {
    return canUseQuizAction(quiz, QUIZ_ACTIONS.MANAGE_QUIZ)
}

export function canManageIntegrations(quiz = {}) {
    return canUseQuizAction(quiz, QUIZ_ACTIONS.MANAGE_INTEGRATIONS)
}

export function canViewCrm(quiz = {}) {
    return canUseQuizAction(quiz, QUIZ_ACTIONS.VIEW_CRM)
}

export function assertQuizActionAllowed(quiz = {}, action) {
    if (canUseQuizAction(quiz, action)) {
        return true
    }

    throw new Error(getQuizActionDeniedMessageKey(action))
}

export function getQuizActionDeniedMessageKey(action) {
    const messages = {
        [QUIZ_ACTIONS.MANAGE_QUIZ]: 'teamPermissionDeniedManageQuiz',
        [QUIZ_ACTIONS.COPY]: 'teamPermissionDeniedCopy',
        [QUIZ_ACTIONS.MANAGE_INTEGRATIONS]: 'teamPermissionDeniedIntegrations',
        [QUIZ_ACTIONS.VIEW_CRM]: 'teamPermissionDeniedCrm',
        [QUIZ_ACTIONS.MOVE]: 'teamPermissionDeniedTransfer',
        [QUIZ_ACTIONS.DELETE]: 'teamPermissionDeniedDelete',
        [QUIZ_ACTIONS.RESTORE]: 'teamPermissionDeniedDelete',
        [QUIZ_ACTIONS.SHARE]: 'teamPermissionDeniedShare',
        [QUIZ_ACTIONS.PUBLISH]: 'teamPermissionDeniedPublish',
    }

    return messages[action] || 'teamPermissionDeniedDefault'
}
